var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check"},[_c('van-checkbox-group',{model:{value:(_vm.result),callback:function ($$v) {_vm.result=$$v},expression:"result"}},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"list"},[_c('div',[_vm._v(_vm._s(item.label))]),_c('div',[_c('van-checkbox',{attrs:{"name":item.value}})],1)])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }